<script lang="ts">
  import moneyFormatters from "@shared/filters/money.js";
  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";

  export let input: any = null;
  export let formatType: string = "default";

  let negative: boolean;
  let formatted: string = null;

  $: {
    negative = input < 0;
    input = Math.abs(input);
    if (formatType == "default") {
      formatted = moneyFormatters.filter()(input);
    } else if (formatType == "2") {
      formatted = moneyFormatters.filter2()(input);
    } else if (formatType == "3") {
      formatted = moneyFormatters.filter3()(input);
    } else if (formatType == "4") {
      formatted = moneyFormatters.filter4()(input);
    } else if (formatType == "5") {
      formatted = moneyFormatters.filter5()(input);
    }
  }

</script>

{#if $CurrentUserStore?.role != "supplier"}
  {negative ? "-" : ""}{formatted}
{/if}
